import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd, NavigationStart, ActivatedRoute } from "@angular/router";
import { ProgramEditorService } from "../../../common/program-editors/program-editor.service";
import { MessageService } from "primeng/components/common/messageservice";
import { TypesService } from "../../../common/types.service";
import { Subscription } from "rxjs/Subscription";
import { Program } from "@models/program";
import { environment } from "../../../../environments/environment";
import { RequestService } from "../../request.service";

@Component({
    templateUrl: "./addition-review.component.html"
})

export class AdditionReviewComponent implements OnInit, OnDestroy {
    public id: number;
    public program: Program;
    public programSub: Subscription;
    currentTab: number;
    public tabSub: Subscription;
    public contactInfoValid: boolean = false;
    public contactInfoValidSub: Subscription;
    public initialized: boolean = false;
    public confirmApproveVisible: boolean = false;
    public confirmDenyVisible: boolean = false;

    public seenContactInfo: boolean = false;
    public seenDetails: boolean = false;
    public seenServices: boolean = false;
    public seenRequester: boolean = false;
    public requestTooltip: string = "";

    constructor(
        public editorService: ProgramEditorService,
        private typeService: TypesService,
        public route: ActivatedRoute,
        public router: Router,
        private requestService: RequestService,
        private messageService: MessageService) {
        this.requestTooltip += "You must view all tabs before accepting this request and creating a program.";
        this.requestTooltip += "You may make changes to the program data by editing the fields below before accepting the request."
    }

    ngOnInit(): void {
        this.editorService.dataReady = false;
        this.editorService.agencies = undefined;
        this.id = +this.route.snapshot.params["id"];

        this.getCities();
        this.getAgencies();
        this.getRequest();
        this.subscribeToProgram();
        this.subscribeToCurrentTab();
        this.subscribeToContactInfoValidity();
        this.changeTab(1);
    }

    ngOnDestroy(): void {
        if (this.programSub != undefined) { this.programSub.unsubscribe(); }
        if (this.tabSub != undefined) { this.tabSub.unsubscribe(); }
        if (this.contactInfoValidSub != undefined) { this.contactInfoValidSub.unsubscribe(); }
    }

    getCities(): void {
        if (this.editorService.cities == undefined) {
            this.typeService.getCities().subscribe(
                response => {
                    this.editorService.cities = response;
                    this.editorService.completeCitiesFetch();
                }
            );
        }
    }

    getAgencies(): void {
        this.typeService.getAgencies().subscribe(
            response => {
                this.editorService.agencies = response;
                this.editorService.completeAgenciesFetch();
            }
        );
    }

    moveToTab(tab: number): void {
        tab = +tab;
        if (environment.editorBypassValidation) {
            this.changeTab(tab);
            return;
        }

        if (!this.contactInfoValid) {
            this.editorService.updateShowContactInfoErrors(true);
            this.changeTab(1);
            return;
        } else {
            this.editorService.updateShowContactInfoErrors(false);
        }

        this.changeTab(tab);
    }

    private changeTab(tab: number) {
        if (this.currentTab === tab) { return; }
        let link: string = "/review/add/" + this.id + "/";
        switch (tab) {
            case 1:
                link += "contact-info";
                break;
            case 2:
                link += "details";
                break;
            case 3:
                link += "services";
                break;
            case 4:
                link += "requester";
                break;
        }

        this.router.navigate([link]);
    }


    getRequest(): void {
        this.requestService.getAdditionRequestForReview(this.id).subscribe(
            response => this.editorService.updateProgram(response)
        );
    }

    subscribeToContactInfoValidity(): void {
        this.contactInfoValidSub = this.editorService.contactInfoValid$.subscribe(x => this.contactInfoValid = x);
    }

    subscribeToCurrentTab(): void {
        this.tabSub = this.editorService.currentTab$.subscribe(x => {
            this.currentTab = x;
            switch (this.currentTab) {
                case 1:
                    this.seenContactInfo = true;
                    break;
                case 2:
                    this.seenDetails = true;
                    break;
                case 3:
                    this.seenServices = true;
                    break;
                case 4:
                    this.seenRequester = true;
                    break;
            }
            if (!this.initialized) { this.initialized = true; }
        });
    }

    subscribeToProgram(): void {
        this.programSub = this.editorService.program$.subscribe(x => this.program = x);
    }

    confirmDeny(): void {
        this.requestService.denyRequest(this.id).subscribe(
            response => {
                this.confirmDenyVisible = false;
                this.messageService.add({ severity: "success", summary: "Success", detail: response.message });
                setTimeout(() => this.router.navigate(["/requests"]));
            },
            error => {
                this.messageService.add({
                    severity: "error",
                    summary: "An Error Occurred",
                    detail: "An error occurred while attempting to deny this request. Please try again."
                });
            }
        );
    }

    confirmApprove(): void {
        this.requestService.approveAddition(this.id, this.program).subscribe(
            response => {
                this.confirmApproveVisible = false;
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: response.message
                });
                setTimeout(() => this.router.navigate(["/requests"]));
            }
        );
    }

    openAcceptConfirmation(): void {
        if (this.seenContactInfo && this.seenDetails && this.seenServices && this.seenRequester) {
            if (!this.contactInfoValid) {
                this.editorService.updateShowContactInfoErrors(true);
                this.changeTab(1);
                this.messageService.add({
                    severity: "error",
                    summary: "Unable To Approve",
                    detail: "Information is invalid please fill all required fields."
                });
            } else {
                this.confirmApproveVisible = true;
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Unable To Approve",
                detail: "You must view all tabs in order to accept this request and add a program."
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/requests/review/add/addition-review.component.ts